import { AboutComponent } from '../../components/core/AboutComponent'
import { ContactComponent } from '../../components/core/ContactComponent'
import { HeroComponent } from '../../components/core/HeroComponent'
import { PortfolioComponent } from '../../components/core/PortfolioComponent'
import { ServicesComponent } from '../../components/core/ServicesComponent'
import { TestimonialsComponent } from '../../components/core/TestimonialsComponent'
export function HomePage() {
  return (
    <div className="min-h-screen bg-background">
      <HeroComponent />
      <ServicesComponent />
      <AboutComponent />
      <PortfolioComponent />
      <TestimonialsComponent />
      {/* <PricingComponent /> */}
      <ContactComponent />
    </div>
  )
}
